import React from 'react'
import ReactDOM from 'react-dom'
import Style from './Overlay.module.css'

export const InfoOverlay = ({ children, isOpen }) => {
  if (!isOpen) {
    return null
  }
  return ReactDOM.createPortal(<div className={Style.infoOverlayWrapper}> {children}</div>, document.getElementById('overlay'))
}
